<template lang="pug">
div
  v-card-title {{ item.user.full_name }}
  v-card-text.pb-0

    server-data(
      ref="recommendationList"
      :method="getMentored"
      :serializeData="serializeData"
      v-slot="{ serverData, loading }"
    )
      .d-flex.mt-4.align-center
        h4 Наставляемые
        v-chip(small color="primary").ml-2 {{ serverData.length }}
        v-spacer
        //- v-btn(color="primary" icon outlined @click="addMentor"): v-icon mdi-plus
      data-wrapper(
        :loading="loading"
        :skeleton-items-count="4"
        :has-items="!!serverData.length"
        skeleton-type="paragraph"
        :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
      )
        template(#no-data)
          v-alert(type="info" prominent text) Еще нет наставляемых

        v-list
          v-list-item.lighten-4.mb-2.sdo-radius.py-2(
            v-for="({ user, chat }, idx) in serverData"
            :key="idx"
            @click="$emit('selectMentored', user.id)"
          )
            v-list-item-avatar(size="24" color="primary").white--text {{ idx + 1}}
            v-list-item-title: strong {{ user.full_name }}
            v-list-item-action
              v-badge(:value="chat.exists_unread_messages" dot overlap color="error")
                v-btn(icon color="secondary" @click.stop="openChat(chat, user)"): v-icon mdi-chat
</template>
<script>
import DataWrapper from '@/components/DataWrapper.vue';
import PracticeCard from './recommendation/RecomendationListDetail.vue';

export default {
  components: {
    DataWrapper,
    PracticeCard,
  },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
    async serializeData(users) {
      const promises = users.map((i) => this.$api.mentoring
        .openChat(this.$user.organization.id, i.user_id, { expand: 'exists_unread_messages' })
        .then(({ item }) => ({ ...i, chat: item })));
      const result = await Promise.all(promises);
      return result;
    },
    getMentored() {
      const params = {
        'search[mentor_id]': this.item.user_id,
        expand: 'user',
      };
      return this.$api.mentoring.requestList(this.$user.organization.id, params);
    },
    async openChat(chat, { full_name: fullName }) {
      chat.open({
        title: 'Чат c наставляемым:',
        subtitle: fullName,
      });
    },
    addMentor() {
    },
  },
};
</script>
